import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIllustration = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 778,
	height: 807,
	fill: "none",
	viewBox: "0 0 778 807",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_21226_6072)",
		children: [
			/* @__PURE__ */ _jsx("rect", {
				width: 402.5,
				height: 408.3,
				x: 67.4,
				y: 115.7,
				fill: "url(#paint0_linear_21226_6072)"
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 309.9,
				cy: 468.9,
				r: 49.7,
				fill: "#fdc564"
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 113.3,
				cy: 405.8,
				r: 30.3,
				fill: "#fa8331"
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 159.5,
				cy: 415.6,
				r: 30.3,
				fill: "#fa8331"
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 201.2,
				cy: 411,
				r: 30.3,
				fill: "#fa8331"
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 171.2,
				cy: 372.6,
				r: 30.3,
				fill: "#fa8331"
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 143.2,
				cy: 377.8,
				r: 30.3,
				fill: "#fa8331"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#606043",
				d: "M52.4 431.9c175.3 28.6 241.2 97.7 258.5 123.7H52.4z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#9ca36c",
				d: "M156.9 555H293c7-21.5 88.2-63.6-32.9-59.3-36.5 1.3-86.6 38.9-103.2 59.3"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#606043",
				d: "M491 431.9c-175.3 28.6-251 97.4-268.3 123.4h270.2l-1-61.7z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#f16b47",
				d: "M370.1 326.1c-41.6 78.7-13.6 119.7 5.6 130.3 25.8-13.3 25.2-38.8 23.7-57.3-7.1-91.2-26.7-73-29.3-73M82.1 305c-41.7 78.7-13.6 119.6 5.6 130.3 25.8-13.3 25.2-38.8 23.7-57.3-7.1-91.2-26.7-73-29.3-73"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#6b4031",
				d: "M381.4 497.9H371c0-46 .4-139.7 2.2-146 2.3-7.7 4.6 4.7 4.6 4.3z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#6b4031",
				d: "m378.8 393.8-6.2-3.5c4.5-8 14-24.4 15.8-24.9 2.1-.6 2.5-.3 2.3 2.3-.9 3.2-7.9 17.4-11.9 26.1m-.6 20.2-6.7 2.4c-3-8.8-9-26.8-8.1-28.4 1-2 1.4-2 3.2-.2 1.8 2.8 7.7 17.5 11.6 26.2m-1.2 43.7-7 2.3c-3-8.8-8.8-26.7-8-28.3 1-2 1.4-2.1 3.2-.2 1.8 2.7 7.7 17.4 11.6 26.2m3.3-22.9-6.2-3.5c4.5-8 14-24.4 15.8-24.9 2.1-.6 2.5-.3 2.3 2.3-.9 3.2-7.9 17.4-11.9 26.1m-286.7 42H83c0-46 .4-139.7 2.2-146 2.3-7.7 4.6 4.6 4.6 4.3z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#6b4031",
				d: "m90.8 372.7-6.2-3.5c4.5-8.1 14-24.4 15.8-24.9 2.1-.6 2.5-.3 2.3 2.3-.9 3.2-7.9 17.4-11.9 26.1m-.6 20.3-6.8 2.3c-3-8.8-8.8-26.8-8-28.4 1-2 1.4-2 3.2-.2 1.8 2.8 7.7 17.5 11.6 26.2M89 436.6l-6.9 2.3c-3-8.8-8.8-26.7-8-28.3 1-2 1.4-2.1 3.2-.3 1.8 2.8 7.7 17.5 11.6 26.3m3.2-22.9-6.2-3.5c4.5-8 14-24.4 15.8-24.9 2.1-.6 2.5-.3 2.3 2.3-.9 3.2-7.9 17.4-11.9 26.1m68.7 94h-10.4c0-46 .4-139.6 2.3-145.9 2.2-7.8 4.5 4.6 4.5 4.3z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#6b4031",
				d: "m157 420.6-6.3-3.5c4.6-8 14-24.4 15.8-24.9 2.1-.6 2.5-.3 2.3 2.3-.8 3.2-7.9 17.4-11.8 26.1"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#6b4031",
				d: "m157 407-6.8 2.3c-3-8.8-8.9-26.7-8-28.3.9-2 1.3-2.1 3.2-.3 1.8 2.8 7.7 17.5 11.6 26.3"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#fc8e26",
				d: "M409.4 303.4c-41.7 78.7-13.7 119.6 5.5 130.3 25.8-13.3 25.3-38.8 23.8-57.3-7.2-91.2-26.7-73-29.3-73"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#6b4031",
				d: "M420.6 475.2h-10.4c0-46 .5-139.7 2.3-146 2.3-7.7 4.6 4.6 4.6 4.3z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#6b4031",
				d: "m418.1 371-6.2-3.4c4.5-8.1 14-24.4 15.7-25 2.2-.5 2.5-.2 2.4 2.4-.9 3.1-8 17.4-11.9 26m-.6 20.3-6.8 2.4c-3-8.8-8.9-26.8-8-28.4.9-2 1.3-2 3.2-.2 1.8 2.8 7.7 17.5 11.6 26.2m-1.3 43.7-6.8 2.3c-3-8.8-8.9-26.7-8-28.3.9-2 1.3-2.1 3.2-.3 1.8 2.8 7.7 17.5 11.6 26.3m3.2-22.9-6.2-3.5c4.5-8 14-24.4 15.8-24.9 2-.6 2.4-.3 2.3 2.3-.9 3.2-8 17.4-11.9 26.1"
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 421.4,
				height: 461.8,
				x: 57.9,
				y: 104.9,
				stroke: "#fff",
				strokeWidth: 27.9
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 445.4,
				height: 26,
				x: 47.8,
				y: 174.3,
				fill: "#fff"
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 521,
				height: 46.7,
				x: .9,
				y: 551.6,
				fill: "#674644",
				rx: 8
			}),
			/* @__PURE__ */ _jsxs("g", {
				clipPath: "url(#clip1_21226_6072)",
				children: [/* @__PURE__ */ _jsx("path", {
					fill: "url(#paint1_linear_21226_6072)",
					d: "M423.3 34h354.5v773H403s-32.2-173.4 0-286.5C456.7 332 423.3 34 423.3 34"
				}), /* @__PURE__ */ _jsx("path", {
					fill: "#faefe4",
					d: "M576 34h64.5v773H529.2s-9.6-173.4 0-286.5C545.2 332 576 34 576 34"
				})]
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#ffbb96",
				d: "m683.6 360.9-9.3 22-31.1-13.3 8.6-19.4c-12.6-19-11-35.7-8.6-41.7 13-25 26.2-19.6 31.1-13.8 8.8-8.7 17 .7 20 6.5 5.2-2.2 9 6.6 10.3 11.3 15.8 14.9 0 20-5.9 27.3 3.3 16.3-8.8 17.1-15.1 21"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#efa27a",
				strokeLinecap: "round",
				strokeWidth: 1.1,
				d: "M680.4 343.3a21 21 0 0 0-4-18.8m0 0c-12.3-2.2.1 0-.4-.2.6-.5 1-3 1.5-4.6zm0 0c2.4 3.1 8.8 8.9 10.4 5.1 2-4.7 3-32.6-19.2-17"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#efa27a",
				strokeLinecap: "round",
				strokeWidth: 1.1,
				d: "M648.8 357.8c.5-1 3.5-6.4 2.6-8-11.8-19.2-10-34.7-9-38.3 2-7.4 8.6-16.9 14.3-19 6-2.3 24-6.6 15.3 17"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#efa27a",
				strokeLinecap: "round",
				strokeWidth: 1.1,
				d: "M674.2 294.7c10.5-8 28.9 3 11.8 17.5"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#efa27a",
				strokeLinecap: "round",
				strokeWidth: 1.1,
				d: "M693.5 300.8c11.4 0 17.2 19.5-4 27.6"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#efa27a",
				strokeLinecap: "round",
				strokeWidth: 1.1,
				d: "M703.5 312.6c6.6 1.4 15.4 15.8-6 26.3-7.5 2.6-12.9-4.6-8.4-10.5"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#ffbb96",
				d: "m169 304 9.2 21.9 31.2-13.3-8.6-19.4c12.6-18.9 11-35.6 8.6-41.6-13-25-26.2-19.6-31.2-13.8-8.8-8.8-16.9.6-19.9 6.5-5.2-2.3-9 6.5-10.4 11.2-15.7 15 0 20 6 27.3-3.3 16.3 8.8 17.2 15.1 21.1"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#efa27a",
				strokeLinecap: "round",
				strokeWidth: 1.1,
				d: "M172.2 286.4a21 21 0 0 1 4-18.9m0 0c12.3-2.2-.1 0 .4-.2-.7-.5-1-3-1.5-4.6zm0 0c-2.5 3.2-8.9 9-10.4 5.2-2-4.7-3-32.7 19.2-17"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#efa27a",
				strokeLinecap: "round",
				strokeWidth: 1.1,
				d: "M203.8 300.8c-.5-1-3.6-6.3-2.6-7.9 11.8-19.3 10-34.7 9-38.4-2-7.4-8.7-16.9-14.3-19-6.1-2.3-24-6.5-15.3 17.1"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#efa27a",
				strokeLinecap: "round",
				strokeWidth: 1.1,
				d: "M178.4 237.7c-10.5-7.9-29 3-11.8 17.5"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#efa27a",
				strokeLinecap: "round",
				strokeWidth: 1.1,
				d: "M159.1 243.9c-11.4 0-17.2 19.5 4 27.6"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#efa27a",
				strokeLinecap: "round",
				strokeWidth: 1.1,
				d: "M149 255.7c-6.5 1.3-15.3 15.8 6 26.2 7.6 2.6 13-4.6 8.5-10.4"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#673f3c",
				d: "m492.5 295.4-33.3 24.4c-24.4 0-237.7 203.8-9.6 246.3 88.1 16.4-.5 128.9 43 134.8 164.5 22.7 168.8-179.4 87.8-187C585 503 599 479.7 599 446.4c0-58.6-59-128.2-106.6-151"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#5f3734",
				d: "M496.4 420.7c-15.4 35.7 14.2 95 21.4 109.4l.2.3c6.7 13.4-52.8-1.1-57.2 4.8-10.6-33.6-22.7-114.8 0-109 20.3 5.3 33.9-3.8 35.6-5.5m-81.1 34.2v-.1q.3 0 0 0c.5 11.8-19.8 39.3-28.9 51.2s-9.3 29.2-14.9 34.2c-3.8-35-6.1-102.6 14.9-92.4 18.7 9 28 7.5 29 7"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#ffbb96",
				d: "M388 492c16-10 8.5-50 2.8-68.8l71 38.9c-2.4 28.1-10 40.5 4.3 46.7 18.7 8.2 40.9 9.7 51.3 28.2 8 14.3-95.8 95.6-118.9 81.2-18.4-11.5-51.9-89.2-56.6-109.4 10.8-3.1 30-6.7 46-16.8"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#5f3734",
				d: "m536.3 591.2-.1-.6q.2 0 .1.6c2.5 11.7-3 41.8 5.3 54 17 24.7-24.4 48.8-28.9 54.8-10.6-33.6-25.5-104.3-2.9-98.5 20 5.2 26.1-7.4 26.5-10.3"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#f7aa81",
				fillOpacity: .6,
				d: "M410.6 495.8c18-5.3 43.8-17.5 50.4-35l-72.7 16.7c2.8 8 5.8 23.2 22.3 18.3"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#ffbb96",
				d: "M348 403c0-23.5 6.3-69.8 11.4-90.3 111.7-69.6 141.3 20.4 144 71 19.6-4.1 25.5 9.5 14.9 27.8-19.2 32.9-31.3 15-35.5 22.6-2.6 4.7-8.6 20.5-16.2 26.6-10 8-52.1 25.8-66 27.5-14 1.7-27.3-10.7-46.7-37.9-10.6-14.9-7.7-29.4-6-47.4"
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 2.3,
				cy: 2.3,
				r: 2.3,
				fill: "#fff",
				transform: "matrix(-1 0 0 1 497.8 422.7)"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#e88653",
				strokeLinecap: "round",
				strokeWidth: 1.8,
				d: "M402.6 459.9c-2 2-8.3 1.4-10.5-2.7"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#673f3c",
				d: "m430.1 369 2.2-5q.3-.6.8-.7c12.6-1.9 24.7 8.6 31.6 17 .8.9-.3 2-1.3 1.3a94 94 0 0 0-12.6-7.4c-5-2.3-14.4-3.4-19.8-3.7a1 1 0 0 1-.9-1.5m-39.4-3.5-1-5.4a1 1 0 0 0-.6-.7c-10.2-5-22.3 2-29.6 8.2-1 .7 0 2 1 1.6a65 65 0 0 1 11.8-3.9 54 54 0 0 1 17 1.4c.8.2 1.5-.5 1.4-1.2"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#e88653",
				strokeLinecap: "round",
				strokeWidth: 1.8,
				d: "M393 397.3a31 31 0 0 1-7 9c-2.4 1.7-4.6 2.4-4 5.5.3 2.3 3.3 3.3 4.7 3.5"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#2c2727",
				d: "m450.8 398.4-.1.6-.4.4h-.5q-.3 0-.5-.3l-1-.9-4-2.7a19 19 0 0 0-18.2-.7l-.6.1-.5-.3-.2-.6q0-.3.3-.5l1.2-1c5.6-4.2 14-4.8 20.4-.8a9 9 0 0 1 4 6.7"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#2c2727",
				stroke: "#2c2727",
				strokeWidth: .9,
				d: "M454.2 393.2q-3.5.4-6 0-.7.1-.6.8c.9 2 2.1 4.7 2.6 4.8s2.8-2.9 4.4-4.9q.3-.6-.4-.7Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#2c2727",
				stroke: "#2c2727",
				strokeWidth: .9,
				d: "M450.7 391.2q-3.4.5-6 .1-.7.1-.5.7a12 12 0 0 0 3 3.5c.4.1 2.4-1.8 4-3.6q.3-.6-.5-.7Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#2c2727",
				d: "M365.7 386.5v.5l.2.4.4.1.4-.1 1.1-.5q2-.9 4-1.4a16 16 0 0 1 15.3 4.5l.5.1.7-.5-.1-.5-.8-1a16 16 0 0 0-16.6-6 8 8 0 0 0-5 4.4"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#2c2727",
				stroke: "#2c2727",
				strokeWidth: .9,
				d: "M371.1 382.2q-3.4-.6-5.8-1.6-.7-.2-.7.5a21 21 0 0 0 1.8 5.6c.4.2 3-2.1 4.9-3.7q.4-.5-.2-.8Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#2c2727",
				stroke: "#2c2727",
				strokeWidth: .9,
				d: "M375.5 382q-3.5-.7-5.8-1.7-.8-.2-.8.5c.2 2 .4 4.4.8 4.5.4.2 3.8-1.3 6-2.6q.3-.5-.2-.8Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#673f3c",
				d: "M351.5 367.9c1.4-18.1 61.2-42.1 96.3-54 13.7 39.9 28 75.6 57.2 70.2 29.1-5.3 16.5-73.3 6.4-90-8-13.3-40.7-19.5-56-17.7-52.4-28-84.4 6-116.6 42.2-25.7 29.1-4.1 70.1 9.2 87.8-.6-9.5 2-20.4 3.5-38.5"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#e88653",
				strokeLinecap: "round",
				strokeWidth: 2.4,
				d: "M507 391.6c5-1.7 9.8 3.4 5.7 10.8"
			}),
			/* @__PURE__ */ _jsx("mask", {
				id: "mask0_21226_6072",
				width: 46,
				height: 21,
				x: 379,
				y: 429,
				maskUnits: "userSpaceOnUse",
				style: { maskType: "alpha" },
				children: /* @__PURE__ */ _jsx("path", {
					fill: "#643d1d",
					d: "M411.7 433.2c-18-.5-26.8-2.2-31.8-3.8 3.2 16.7 13 20.2 22 20.2 11.3 0 23-16 22.7-17-.3-1.1-5 .5-13 .6"
				})
			}),
			/* @__PURE__ */ _jsxs("g", {
				mask: "url(#mask0_21226_6072)",
				children: [
					/* @__PURE__ */ _jsx("path", {
						fill: "#643d1d",
						d: "M421.1 433.5a159 159 0 0 1-42.4-5.2c4.4 21.4 18.1 29.1 30.9 27.5 16.1-2 28.1-19 27.7-20.4s-14.1-1.7-16.2-2"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#d36b6b",
						d: "M425.4 439.2c18.3 2.4 17.6 16.6 16.3 21.1-2.8-3.1-31.2-5.7-44.9-5.7-.4-.6-1-3.6 3.3-7.6a48 48 0 0 1 25.3-7.8"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#fff",
						d: "M408.9 443c-25.1-1.2-24.6-9.8-23.6-14.3 3.3 3 34.3 3.9 49 3.1.5.6 1 3.6-.9 7.8s-12.6 4-24.5 3.5"
					})
				]
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#a7c0c1",
				d: "M167 327c-17.4 9 92.3 191.3 146.2 270.9 28.1 0 47.2-97.9 32.8-101.8-11.5-3.2-83.6-135.9-118.2-201.8-13-5.8-46 19.4-60.9 32.8M687 392c16 11-114.4 179-177.3 251.8-28-3.4-35.3-102.8-20.6-105 11.9-1.8 99-125 141.2-186.5 13.6-4.2 43.4 24.8 56.6 39.8"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#a7c0c1",
				d: "M396.7 600.5c-9.5-4-38.4-53.8-19.5-101.8.4-1-.3-2-1.3-2h-29.1q-1 0-1.3.9l-33 87.5q-.2.5-.7.8c-19.6 11.9 6.8 115.7 7.8 134.6.9 15.1-9 68.1-14.2 93.6q-.2.8.5 1.4c69.3 53.1 167.8 22.7 216.5.1.8-.3 1-1.3.6-2.1-10-19.5-10.9-118-10.9-163.2l.1-.5 38.9-90.8v-1.2c-9.7-20.4-56.2-43.1-65.5-42-9.4 1-61.8 96.2-88.9 84.7"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#c3d2d3",
				d: "M400.2 600.6c20-9 63.4-56.8 79.9-81.4 2.5 2.3 12.1-8.6 22.4 4.2 4.2 5.3-15.4 44.3-28.5 50.8-4.3 2.2-6.2 3.5-11 2.7.7 5.4-1.1 9-4.4 12.7-8 9-63.4 20.5-58.4 11"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#a7c0c1",
				d: "M472.3 508.4c-13 25.8-55.5 80.5-69.7 89-10.1 6 52.3-3.3 55.8-15a25 25 0 0 0 1.5-9.7c1.4 1.6 4.4 2.3 10.8-1.8 11.7-7.4 32.8-41.4 29.7-47.5-3.2-6-26.9-17.5-28.1-15"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#c3d2d3",
				d: "M406.5 606.1c-14.5-16.5-31.9-80.3-36.8-109.4-3.2 1-14-.7-19.3 3.5s-9.4 37.4-1 48.2c2.7 3.6 5 8.5 9.7 8.6-2.9 3.2-3.1 9.6-1.8 13 4.5 11.4 49.8 46.8 49.2 36.1"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#a7c0c1",
				d: "M377.1 497.1c1.4 29.8 23.7 94 32.9 110 6.1 10.7-50.3-30.3-48.6-42.9.7-5.5 1.6-8.2 2.6-9.7-2 .8-5.2.3-9.5-6.4-8-12.1-5.6-43.1 0-47.5s19.3-2.4 22.6-3.5"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#8eb0b2",
				strokeLinecap: "round",
				strokeWidth: 1.8,
				d: "M687.5 394.1c-7-16.2-45.9-43.3-52.5-42-4.6.9-4.9 0-8.4 5.7l-7 11.4m-393-75c-19.3-1.3-45.4 22.7-50.9 26.8-5.2 4-12 7.5-10.5 14 1.8 7.9 7.8 20.3 8.4 21"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#c3d2d3",
				d: "m406.7 607.6-1.8-.1a572 572 0 0 0-3.5 60c-.1 24.9.4 49.9 2.4 74.9 2.9 30.9 5.9 62 13.8 92.2 1.3 3.8 2 7.8 5.3 11.3l1.1-1.5c-2.2-2.4-3.2-6.7-4.2-10.4-6.8-30-9.2-61.2-11.5-92a975 975 0 0 1-1.8-74.5l.2-48z"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#c3d2d3",
				strokeWidth: 1.8,
				d: "M404.6 595.7c0 2.6 5.6 7 1.3 14.9"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#83a9ab",
				strokeLinecap: "round",
				strokeWidth: 1.8,
				d: "m312.5 567.7-8 39.4c-2.1 16.6 19.3 130.2 21.6 137.1m178.3-115.6 7.3 18.8c.6 8.8 0 23.7 0 31.1M507.5 522c6 4.1 9.4 6.4 14.2 14.3m-175.1-39.2c-6.5 1.8-11.4 5.9-16.2 13.8"
			}),
			/* @__PURE__ */ _jsx("ellipse", {
				cx: 383.7,
				cy: 702.5,
				fill: "#83a9ab",
				fillOpacity: .7,
				rx: 1.8,
				ry: 8.3,
				transform: "rotate(-89 383.7 702.5)"
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 384.2,
				cy: 702.5,
				r: 4.8,
				fill: "#c3d2d3",
				transform: "rotate(-2 384.2 702.5)"
			}),
			/* @__PURE__ */ _jsx("ellipse", {
				cx: 388.1,
				cy: 760.3,
				fill: "#83a9ab",
				fillOpacity: .7,
				rx: 1.8,
				ry: 8.3,
				transform: "rotate(-89 388.1 760.3)"
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 388.5,
				cy: 760.3,
				r: 4.8,
				fill: "#c3d2d3",
				transform: "rotate(-2 388.5 760.3)"
			}),
			/* @__PURE__ */ _jsx("ellipse", {
				cx: 385.5,
				cy: 648.2,
				fill: "#83a9ab",
				fillOpacity: .7,
				rx: 1.8,
				ry: 8.3,
				transform: "rotate(-89 385.5 648.2)"
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 385.9,
				cy: 648.2,
				r: 4.8,
				fill: "#c3d2d3",
				transform: "rotate(-2 386 648.2)"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#a88381",
				d: "M70.7 570.8c-3-1.1 1.2-8.6 3.7-12.2l8.5 4.7c-2.9 3-9.2 8.6-12.2 7.5m65.9.2c-2 2.5-7.7-4-10.2-7.5l7.2-6.5c1.9 3.7 5 11.5 3 14"
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 104.2,
				cy: 523.1,
				r: 49.5,
				fill: "#9b5d59"
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 104.2,
				cy: 523.1,
				r: 37.5,
				fill: "#fff9de"
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 104.2,
				cy: 554.1,
				r: 1.5,
				fill: "#6a3b00"
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 135.2,
				cy: 523.1,
				r: 1.5,
				fill: "#6a3b00"
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 73.2,
				cy: 524.1,
				r: 1.5,
				fill: "#6a3b00"
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 104.2,
				cy: 492.1,
				r: 1.5,
				fill: "#6a3b00"
			}),
			/* @__PURE__ */ _jsx("line", {
				className: "hand-black",
				x1: 104.2,
				x2: 104.2,
				y1: 505.1,
				y2: 522.1,
				stroke: "#6a3b00",
				strokeLinecap: "round",
				strokeWidth: 3
			}),
			/* @__PURE__ */ _jsx("line", {
				className: "hand-red",
				x1: 104.2,
				x2: 104.2,
				y1: 505.1,
				y2: 522.1,
				stroke: "#9d230f",
				strokeLinecap: "round",
				strokeWidth: 3
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 104.2,
				cy: 525.1,
				r: 3,
				fill: "#9d230f",
				stroke: "#9d230f"
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 4.2,
				height: 7,
				x: 102.6,
				y: 467.8,
				fill: "#9b5d59"
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 4.2,
				height: 15.5,
				x: 97,
				y: 469.9,
				fill: "#5e3431",
				rx: 1.4,
				transform: "rotate(-90 97 469.9)"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "url(#paint2_linear_21226_6072)",
				d: "M218 525.7c-4.5-1.5-9.9 6.2-12 10.3l.7-12.2c11.3-9 20-7.6 20 8 0 14-15.9 25.8-24.7 30l1.5-7.7c18-11.5 20.1-26.4 14.5-28.4"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#0c8ce2",
				d: "M136.8 516.1c1.8-2.9 62-7 70.9.2-14.2 4.8-52 11.5-70.9-.2"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#6b4031",
				d: "M139.8 517.2c8.3-2.5 50.5-3.8 64.4 0-14.2 4.8-45.5 11.7-64.4 0"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#18a0fb",
				d: "M148.4 574.3c-8.7-8.8-12-42.2-11.6-58.3 11.6 6 56 4 70.8 0-.1 12.5-3 51.3-13 58.3-11.7 8.3-45.2 4.2-46.2 0"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#0c8ce2",
				d: "M148.4 574.3c13-3.3 24.8 1 36.3-4 10-4.3 10-8.8 19.2-18.2-2.1 12.7-.3 16-9.2 22.2-11.7 8.3-45.3 4.2-46.3 0"
			}),
			/* @__PURE__ */ _jsx("g", {
				fill: "#fff",
				clipPath: "url(#clip2_21226_6072)",
				children: /* @__PURE__ */ _jsx("path", { d: "m147.2 548.4-.4-.6q0-.7.8-.8l.4.1q1.3.8 2.4.8 1.3 0 1.3-.9-.2-.8-1.9-1.1c-1.2-.4-2.6-.8-2.6-2.4s1.3-2.5 3-2.5a6 6 0 0 1 2.7.7q.3.2.4.7 0 .7-.8.7h-.4q-1-.6-2-.6t-1.1.8q.2.8 1.9 1.2c1.2.3 2.6.9 2.6 2.3 0 1.7-1.4 2.6-3.1 2.6a6 6 0 0 1-3.2-1m7.3-3.2c0-2.3 1.8-4.2 4.4-4.2q1.9 0 3 1l.2.6q0 .8-.9.9l-.5-.2q-.7-.7-1.8-.7c-1.4 0-2.5 1.2-2.5 2.6s1 2.6 2.5 2.6q1.2 0 2-.7 0-.2.5-.2.7 0 .8.8l-.3.6q-1 1-3 1.1a4 4 0 0 1-4.4-4.2m8.5 0c0-2.3 2-4.2 4.5-4.2 2.6 0 4.5 1.9 4.5 4.2s-1.9 4.2-4.5 4.2-4.5-1.9-4.5-4.2m7 0c0-1.4-1-2.6-2.5-2.6a2.5 2.5 0 0 0-2.5 2.6c0 1.4 1 2.6 2.5 2.6 1.6 0 2.6-1.2 2.6-2.6m2.9 0c0-2.3 2-4.2 4.5-4.2 2.6 0 4.5 1.9 4.5 4.2s-2 4.2-4.5 4.2c-2.6 0-4.5-1.9-4.5-4.2m7 0c0-1.4-1-2.6-2.5-2.6a2.5 2.5 0 0 0-2.6 2.6c0 1.4 1.1 2.6 2.6 2.6 1.6 0 2.6-1.2 2.6-2.6m3 .3c0-2.2 1.2-4.5 4.5-4.5 2 0 4 1.5 4 4.2s-2 4.2-4 4.2q-2 0-2.5-1v2.4q-.1.9-1 1a1 1 0 0 1-1-1zm6.7-.3q-.1-2.5-2.4-2.6c-1.3 0-2.5 1-2.5 2.6 0 1.5 1.2 2.6 2.5 2.6s2.4-1 2.4-2.6m3 .6c0-3 2.2-4.7 4-4.7q1 0 1 .9 0 .7-.8.9-2.1.3-2.3 3.1v2.4q0 .8-1 .9a1 1 0 0 1-1-1z" })
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#fff",
				fillOpacity: .1,
				d: "M143.4 546.9c0-3 1.3-4.8 3.3-2.4s6.6 24.4 6.6 24.4c0 1.1-.5 3-2.6 1.5-2.7-1.8-7.3-19.3-7.3-23.5m-1.8-13.5c0-1.3 1-2.1 2.4-1 1.5 1 1.3 3.7 1.3 3.7 0 .5.2 5-1.3 4.3-2-.8-2.4-5.2-2.4-7"
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 371.1,
				height: 18.1,
				x: 406.9,
				y: 8.6,
				fill: "#af6c48"
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 14,
				height: 31.7,
				x: 430.9,
				y: 3.8,
				fill: "#f4e4d0",
				rx: 3.5
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 14,
				height: 31.7,
				x: 487.9,
				y: 3.8,
				fill: "#f4e4d0",
				rx: 3.5
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 14,
				height: 31.7,
				x: 549.9,
				y: 3.8,
				fill: "#f5e3cd",
				rx: 3.5
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 14,
				height: 31.7,
				x: 611.9,
				y: 3.8,
				fill: "#faefe4",
				rx: 3.5
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 14,
				height: 31.7,
				x: 673.9,
				y: 3.8,
				fill: "#f4e4d0",
				rx: 3.5
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 14,
				height: 31.7,
				x: 735.9,
				y: 3.8,
				fill: "#f4e4d0",
				rx: 3.5
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#af6c48",
				d: "M419 15.6c0 9.8-2.9 17.7-16.6 17.7-9.1 0-16.5-7.9-16.5-17.7S393 0 404.6 0c9.2 0 14.4 5.9 14.4 15.6"
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_21226_6072",
			x1: 268.6,
			x2: 210.3,
			y1: 479.4,
			y2: 115.7,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#ffdebd" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#c2eeff"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_21226_6072",
			x1: 489.8,
			x2: 424.1,
			y1: 440.7,
			y2: 432.5,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#f6e3cb" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#f0e5d7"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint2_linear_21226_6072",
			x1: 214.4,
			x2: 214.4,
			y1: 518.2,
			y2: 561.8,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#18a0fb" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#0c8ce2"
			})]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_21226_6072",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 777,
				height: 807,
				fill: "#fff",
				transform: "translate(1)"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip1_21226_6072",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 389,
				height: 773,
				fill: "#fff",
				transform: "translate(388.8 34)"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip2_21226_6072",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 51,
				height: 10.7,
				fill: "#fff",
				transform: "translate(146.8 541)"
			})
		})
	] })]
});
export default SvgIllustration;
